module.exports = __webpack_public_path__ + "people_before.f2d19c89.png";